export default __webpack_public_path__ + "static/media/vitalshock.77c18c1c.png";